import React, { Component } from 'react';
import axios from 'axios';
//import { MDBContainer, MDBIframe } from "mdbreact";
import {
    MDBInput, MDBDatePicker, MDBSelect, toast, ToastContainer, MDBBtnFixedItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge,
    MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';

class BankingInfo extends Component {
    constructor(props) {
        super(props);
        //this.props.loaderOn();
        this.state = {
            modalOpen: true,
            bankFormHidden: true,
            banks: [],
            accountTypes: [],
            idTypes: [],
            accountNumber: '',
            accountName: '',
            accountInitials: '',
            idNumber: '',
            idTypeId: 0,
            accountTypeId: 0,
            bankId: 0,
            sfBankAccountId: 0,
            sfId: 0,
            btnDisabled: false,
            bankInfoPassword: '',
            passwordError: '',
            passwordErrorHidden: true,
            SMSQueryCell: '',
            emailAddress: '',
            acceptsCredits: '',
            accountNumberValid: '',
            accountStatus: '',
            confirmationModalOpen: false,
            msg: '',
            modalTitle: '',
            AgreedToTerms: false,
            termsModalOpen: false,
            TermsNotAGree: false
        }
        this.submitHandler = this.submitHandler.bind(this);
        this.toggle = this.toggle.bind(this);
        this.cancelBankInfo = this.cancelBankInfo.bind(this);
        this.handleBankSelectChange = this.handleBankSelectChange.bind(this);
        this.handleAccountTypeSelectChange = this.handleAccountTypeSelectChange.bind(this);
        this.handleIdTypeSelectChange = this.handleIdTypeSelectChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.readBankingInfoTerms = this.readBankingInfoTerms.bind(this);
        this.toggleTermsModal = this.toggleTermsModal.bind(this);
        this.checkBoxchangeHandler = this.checkBoxchangeHandler.bind(this);
        this.toggleTermsNotAGree = this.toggleTermsNotAGree.bind(this);
        this.props.loaderOff();
    }

    checkBoxchangeHandler(value) {

        if (value == "false") {
            //this.props.showHideNode('bInfo', false);
            this.setState({
                AgreedToTerms: true
            })
        } else {
            //this.props.showHideNode('bInfo', true);
            this.setState({
                AgreedToTerms: false
            })
        }

        //alert(this.state.acceptedTerms);
    };

    readBankingInfoTerms() {
        this.setState({
            termsModalOpen: true
        });
    }

    toggleTermsModal() {
        this.setState({
            termsModalOpen: !this.state.termsModalOpen
        });
    }

    toggleConfirmation() {
        this.setState({
            confirmationModalOpen: !this.state.confirmationModalOpen
        });
        if (!this.state.AgreedToTerms) {
            this.props.history.push({
                pathname: '/salesforce'
            })
        }
    }

    handleIdTypeSelectChange(selected) {
        this.setState({
            idTypeId: selected[0],
            btnDisabled: false
        });
    }

    handleAccountTypeSelectChange(selected) {
        this.setState({
            accountTypeId: selected[0],
            btnDisabled: false
        });
    }

    handleBankSelectChange(selected) {
        this.setState({
            bankId: selected[0],
            btnDisabled: false
        });
    }

    cancelBankInfo() {
        this.props.history.push({
            pathname: '/salesforce/personalInfo'
        })
    }

    async toggle() {
        var dl = new DataLayer();
        let result = await dl.Post('/demonstrator/verifyPassword', this.state.bankInfoPassword, false);
        if (!result.errorOccurred) {
            if (result.data == -1) {
                //no password created yet
                this.setState({
                    passwordError: 'No Password Created Yet. Please go to personal info and create a banking info password by clicking Manage Banking Info Password.',
                    passwordErrorHidden: false
                });
            } else {
                this.setState({
                    modalOpen: !this.state.modalOpen,
                    bankFormHidden: !this.state.bankFormHidden
                });
            }
        } else {
            this.setState({
                passwordError: result.errorMessage,
                passwordErrorHidden: false
            });
        }
    }

    async componentWillMount() {
        var dl = new DataLayer();
        let banksResult = await dl.Get('/demonstrator/GetBanks', 200);
        let accountTypesResult = await dl.Get('/demonstrator/GetAccountTypes', 200);
        let IdTypesResult = await dl.Get('/demonstrator/GetIdTypes', 200);
        let detailResult = await dl.Get('/demonstrator/GetBankAccountInfo', 200);
        let bankSelected = false;
        if (detailResult.data != null) {
            banksResult.data.map((pitem) => {
                if (pitem.bankId == detailResult.data.bankId) {
                    pitem.checked = true;
                    bankSelected = true;
                }
            });
        }
        if (!bankSelected) {
            banksResult.data[0].checked = true;
        }

        let accountTypeSelected = false;
        if (detailResult.data != null) {
            accountTypesResult.data.map((accItem) => {
                if (accItem.bankAccountTypeId == detailResult.data.accountTypeId) {
                    accItem.checked = true;
                    accountTypeSelected = true;
                }
            });
        }

        let idTypeSelected = false;
        if (detailResult.data != null) {
            IdTypesResult.data.map((idItem) => {
                if (idItem.idTypeId == detailResult.data.idTypeId) {
                    idItem.checked = true;
                    idTypeSelected = true;
                }
            });
        }

        if (!bankSelected) {
            banksResult.data[0].checked = true;
        }
        if (!accountTypeSelected) {
            accountTypesResult.data[0].checked = true;
        }
        if (!idTypeSelected) {
            IdTypesResult.data[0].checked = true;
        }
        this.setState({
            banks: banksResult.data,
            accountTypes: accountTypesResult.data,
            idTypes: IdTypesResult.data,
            accountNumber: detailResult.data == null ? '' : detailResult.data.accountNumber,
            accountName: detailResult.data == null ? '' : detailResult.data.accountName,
            accountTypeId: detailResult.data == null ? '' : detailResult.data.accountTypeId,
            bankId: detailResult.data == null ? '' : detailResult.data.bankId,
            sfBankAccountId: detailResult.data == null ? -1 : detailResult.data.sfBankAccountId,
            sfId: detailResult.data == null ? '' : detailResult.data.sfId,
            idTypeId: detailResult.data.idTypeId,
            idNumber: detailResult.data == null ? '' : detailResult.data.idNumber,
            SMSQueryCell: detailResult.data.smsQueryCell,
            emailAddress: detailResult.data.emailAddress,
            acceptsCredits: detailResult.data == null ? 'No' : detailResult.data.acceptsCredits == null ? 'No' : detailResult.data.acceptsCredits.toUpperCase() == 'UNVERIFIED' ? 'No' : 'Yes',
            accountNumberValid: detailResult.data == null ? 'No' : detailResult.data.accountNumberValid == null ? 'No' : detailResult.data.accountNumberValid,
            accountStatus: detailResult.data == null ? 'Closed' : detailResult.data.accountStatus == null ? 'Closed' : detailResult.data.accountStatus.toUpperCase() == 'UNVERIFIED' ? 'Closed' : 'Open',
            AgreedToTerms: detailResult.data == null ? false : detailResult.data.agreedToTerms == null ? false : detailResult.data.agreedToTerms
        })
    }

    async toggleTermsNotAGree() {
        this.setState({ btnDisabled: true, TermsNotAGree: false });
        this.submitHandler();
    }

    async submitForm(e) {
        e.preventDefault();
        if (this.state.AgreedToTerms) {
            this.setState({ btnDisabled: true });
            this.submitHandler();
        } else {
            this.setState({ TermsNotAGree: true})
        }
    }

    async submitHandler(e) {
        //e.preventDefault();
        this.props.loaderOn();
        let requestObject = this.state;

        //event.target.className += " was-validated";
        var dl = new DataLayer();
        let result = await dl.Post('/demonstrator/UpdateBankingInfo', requestObject);
        if (result.errorOccurred) {
            this.props.loaderOff();
            this.setState(
                {
                    btnDisabled: false,
                    confirmationModalOpen: true,
                    msg: 'An error occurred saving details.',
                    modalTitle: 'Failure'
                }
            )
        } else {
            // details saved successfuly get token and request validation. if token not valid request new token and then do validation
            if (this.state.AgreedToTerms) {
                var bearerToken = '';
                if (result.otherInfo == 'invalid') {
                    bearerToken = await dl.GetVerificationToken();
                    await dl.Post('/common/SaveVerificationToken', bearerToken, true);
                } else {
                    bearerToken = result.data.bearerToken;
                }
                let verificationData = {
                    identificationType: this.state.idTypes.filter((item) => (item.idTypeId == this.state.idTypeId))[0].idTypeCode,
                    identityNumber: this.state.idNumber,
                    accountType: this.state.accountTypes.filter((item) => (item.bankAccountTypeId == this.state.accountTypeId))[0].accountType, //this.state.accountTypes[this.state.accountTypeId].accountType,
                    accountNumber: this.state.accountNumber,
                    bank: this.state.banks.filter((item) => (item.bankId == this.state.bankId))[0].bankCode, //this.state.banks[this.state.bankId].bankName,
                    sendOtp: false,
                    phoneNumber: this.state.SMSQueryCell,
                    name: this.state.accountName,
                    email: this.state.emailAddress,
                    initials: this.state.accountInitials
                }

                let verificationResult = await dl.VerifyAccountDetails(verificationData, bearerToken);
                if (verificationResult != undefined) {
                    let postResult = {
                        BankAccountId: result.data.bankAccountId,
                        AcceptsCredits: verificationResult.acceptsCredits,
                        AcceptsDebits: verificationResult.acceptsDebits,
                        AccountNumberValid: verificationResult.accountNumberValid,
                        AccountStatus: verificationResult.accountStatus,
                        AccountTypeValid: verificationResult.accountTypeValid,
                        EmailValid: verificationResult.emailValid,
                        IdentityNumberValid: verificationResult.identityNumberValid,
                        InitialsValid: verificationResult.initialsValid,
                        NameValid: verificationResult.nameValid,
                        OpenForAtleast3Months: verificationResult.openForAtleast3Months,
                        PhoneNumberValid: verificationResult.phoneNumberValid,
                        ResponseMessage: verificationResult.responseMessage,
                    };
                    this.setState({
                        accountStatus: verificationResult.accountStatus,
                        acceptsCredits: verificationResult.acceptsCredits,
                        accountNumberValid: verificationResult.accountNumberValid
                    });
                    var res = await dl.Post('/demonstrator/SaveAccountVerificationResult', postResult);
                    if (res.data == "saved") {
                        this.setState(
                            {
                                confirmationModalOpen: true,
                                msg: verificationResult.accountNumberValid.toUpperCase() == 'YES' ? 'Banking Details Saved and Verification Processed' : 'Banking Details Saved, Account Not Verfified. See Account Verification for Result.',
                                modalTitle: verificationResult.accountNumberValid.toUpperCase() == 'YES' ? 'Success' : 'Failure'
                            }
                        )
                    }
                } else {
                    this.setState(
                        {
                            confirmationModalOpen: true,
                            msg: 'Banking Details Saved, Unable to Verify Account',
                            modalTitle: 'Failure'
                        }
                    )
                }
            } else {
                this.setState(
                    {
                        confirmationModalOpen: true,
                        msg: 'All banking details removed.',
                        modalTitle: 'Info',
                        accountNumber: '',
                        accountName: '',
                        sfBankAccountId: -1,
                        idNumber: '',
                        SMSQueryCell: '',
                        emailAddress: '',
                        acceptsCredits: 'No',
                        accountNumberValid: 'No',
                        accountStatus: 'Closed'
                    }
                )
            }
            this.props.loaderOff();
        }
    }

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value, btnDisabled: false });
    };

    render() {
        return (
            <div>
                <Header headerText='Update Banking Info'
                    hideSearch='true'
                />
                <div hidden={this.state.bankFormHidden}>
                    

                        <MDBCard>
                            <MDBCardBody>
                                <MDBRow>
                                    <MDBCol>
                                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>Account Verification Detail</span>
                                    </MDBCol>
                                </MDBRow>
                                <br />
                                <MDBRow>
                                    <MDBCol md="6">
                                        <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="ellipsis-h" />&nbsp;&nbsp;Accepts Credits: <span style={{ fontWeight: "bold" }}>{this.state.acceptsCredits}</span></MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="ellipsis-h" />&nbsp;&nbsp;Account Number Valid: <span style={{ fontWeight: "bold" }}>{this.state.accountNumberValid}</span></MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="ellipsis-h" />&nbsp;&nbsp;Account Status: <span style={{ fontWeight: "bold" }}>{this.state.accountStatus}</span></MDBCardTitle>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardBody>
                    </MDBCard>
                    <br />
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow>
                                <MDBCol>
                                    <span style={{ fontWeight: "bold", textDecoration: "underline" }}>Disclaimer</span>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <MDBRow>
                                <MDBCol>
                                    I do hereby release, agree to indemnify and hold Umagazini Oluhle (Pty)Ltd, its directors, management, officers, employees and agents free and harmless from any and all costs, losses, expenses, damages (direct, indirect, consequential or otherwise), claims, suits, causes of action or any
other liability or responsibility whatsoever, including attorney’s fees and related costs, resulting from me loading/adding/editing/any other function related to or associated with my banking information being supplied, or which may in any manner be connected with, said Activity as provided herein.
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                    <br />
                    <form onSubmit={this.submitForm} >
                        <MDBCard>
                            <MDBCardBody>
                                <MDBRow>
                                    <MDBCol>
                                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>Account Info</span>
                                    </MDBCol>
                            </MDBRow>
                            
                                <MDBRow>

                                    <MDBCol md="6">
                                        <MDBSelect label="Select Bank"
                                            options={this.state.banks}
                                            selected="Bank"
                                            getValue={this.handleBankSelectChange}
                                            required
                                        />
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <MDBSelect label="Select Account Type"
                                            options={this.state.accountTypes}
                                            selected="AccountType"
                                            getValue={this.handleAccountTypeSelectChange}
                                            required
                                        />

                                    </MDBCol>

                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="4">
                                        <MDBInput
                                            value={this.state.accountNumber}
                                            name="accountNumber"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="accountNumber"
                                            label="Account Number"
                                            required
                                        >

                                        </MDBInput>
                                    </MDBCol>
                                    <MDBCol md="4">
                                        <MDBInput
                                            value={this.state.accountName}
                                            name="accountName"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="accountName"
                                            label="Account Holder Name"
                                            required
                                        >

                                        </MDBInput>
                                </MDBCol>
                                <MDBCol md="4">
                                        <MDBInput
                                        value={this.state.accountInitials}
                                        name="accountInitials"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="accountInitials"
                                        label="Account Holder Initials"
                                        required
                                    />

                                    
                                </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <MDBSelect label="Select ID Type"
                                            options={this.state.idTypes}
                                            selected="IdType"
                                            getValue={this.handleIdTypeSelectChange}
                                            required
                                        />
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <MDBInput
                                            value={this.state.idNumber}
                                            name="idNumber"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="idNumber"
                                            label="ID Number"
                                            required
                                        >

                                        </MDBInput>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <MDBInput
                                            value={this.state.emailAddress}
                                            name="emailAddress"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="emailAddress"
                                            label="Bank Account Email Address"
                                            required
                                        >

                                        </MDBInput>
                                    </MDBCol>
                                <MDBCol md="6">
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn tag="a" color="purple" floating onClick={this.readBankingInfoTerms}>
                                                <MDBIcon icon="glasses" />
                                            </MDBBtn>Read Terms
                                                </MDBCol>
                                    </MDBRow>
                                        <MDBRow>
                                            <MDBCol>
                                                {this.state.AgreedToTerms ? (
                                                    <MDBInput getValue={this.checkBoxchangeHandler} value={this.state.AgreedToTerms} label="I agree to the terms." checked type="checkbox" id="checkbox2" />
                                                ) : (
                                                        <MDBInput getValue={this.checkBoxchangeHandler} value={this.state.AgreedToTerms} label="I agree to the terms." type="checkbox" id="checkbox2" />
                                                    )}
                                            </MDBCol>
                                        </MDBRow>
                                        
                                    </MDBCol>
                                </MDBRow>
                            
                            </MDBCardBody>
                        </MDBCard>
                        <MDBBtn type="submit">Submit Form</MDBBtn>
                    {/*    <MDBBtn disabled={this.state.btnDisabled} color="purple" onClick={this.submitForm}>*/}
                    {/*        Submit Form*/}
                    {/*</MDBBtn>*/}
                    </form>
                </div>
                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Banking Info Password</MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol>
                                Please enter your password to continue.
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <MDBInput
                                    name="bankInfoPassword"
                                    onChange={this.changeHandler}
                                    type="password"
                                    id="bankInfoPassword"
                                    label="Bank Info Password"
                                    required
                                >

                                </MDBInput>
                            </MDBCol>
                        </MDBRow>
                        <div hidden={this.state.passwordErrorHidden}>
                            <MDBRow>
                                <MDBCol>
                                    <span style={{ color: "red" }}>{this.state.passwordError}</span>
                                </MDBCol>
                            </MDBRow>
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggle}>Ok</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={this.cancelBankInfo}>Cancel</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.confirmationModalOpen} toggle={this.state.confirmationModalOpen} centered>
                    <MDBModalHeader>{this.state.modalTitle}</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.msg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleConfirmation}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.TermsNotAGree} toggle={this.state.TermsNotAGree} centered>
                    <MDBModalHeader>Warning</MDBModalHeader>
                    <MDBModalBody>
                        You have not agreed to the terms and conditions. If you choose to proceed we will remove all your banking information. Do you wish to continue.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleTermsNotAGree}>Yes</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ TermsNotAGree: false })}>No</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.termsModalOpen} toggle={this.state.termsModalOpen} size="fluid">
                    <MDBModalHeader>Ecommerce Agreement</MDBModalHeader>
                    <MDBModalBody>

                        <div id="page_1">

                            <div className="flex-row text-center">
                                <p class="p0 ft0">TUPPERWARE SOUTHERN AFRICA (PROPRIETARY) LIMITED</p>
                                <p class="p1 ft0">(REGISTRATION NUMBER 1937/010039/07)</p>
                                <p class="p2 ft0">("Tupperware/We")</p>

                                <p class="p3 ft1">AGREEMENT WITH INDEPENDENT SALES FORCE RELATING TO <nobr>LINKED-SALES</nobr> COMPLETED ON THE</p>

                                <p class="p4 ft1">TUPPERWARE <nobr>E-COMMERCE</nobr> PLATFORM</p>
                            </div>
                            <p class="p5 ft0">The Tupperware <nobr>e-commerce</nobr> platform is there to enhance and not replace our classic distribution channel – the Tupper party®. The <nobr>e-commerce</nobr> platform is in support of your Tupperware business.</p>
                            <p class="p6 ft2">Agreement to participate in the Tupperware online platform</p>
                            <p class="p7 ft3">To support the Tupperware demonstration system, Tupperware Southern Africa provides an online sales platform under tupperware.co.za. Sales of Tupperware products through this platform gives you the opportunity to participate in the sales transaction via the platform and use the platform to open up new customer contacts for party bookings.</p>
                            <p class="p8 ft0">Tupperware will publish your name and contact details (if applicable, your photo) on the platform and give interested end customers the opportunity to contact you via the contact information you provide. Tupperware may also use your data in <nobr>e-mails</nobr> that Tupperware may automatically send to end customers for advertising purposes and in which we name you as a contact person.</p>
                            <p style={{ fontWeight: "bold" }}>THE SALE AND MARGIN</p>
                            <p class="p10 ft4">Jointly, upon completion and payment of a purchase by an end customer via the Tupperware <nobr>E-commerce</nobr> platform and the customer had selected you as the sales force member, you will be entitled to receive a margin based on the total basket purchase price (excluding VAT and excluding the delivery fee). The determinant which will entitle you to a margin on the <nobr>e-commerce</nobr> sale, is the independent sales force member selection made by the customer when making the online purchase on the Tupperware <nobr>E-commerce</nobr> site. Tupperware will inform you of any changes to the margin structure and reserves the right to amend margins in its sole discretion. You retain the option to participate in the Tupperware <nobr>E-commerce</nobr> platform provided you are active and not discontinued from the system due to inactivity. The Retail Inclusive value of the <nobr>e-commerce</nobr> sales completed through the platform, on which you received a margin, will count toward the recognition value for your personal, unit and/or team sales. The said recognition value contributes towards the required incentive levels as well.</p>
                            <p style={{ fontWeight: "bold" }}>BANK ACCOUNT INFORMATION</p>
                            <p class="p12 ft0">The payment of the margin earned by you by virtue of this agreement and based upon the customer selection explained above, Tupperware will require that you capture your bank details on the specified platform. Tupperware will make monthly margin payments to you via bank transfer. Payment will be made into the bank account specified by you and bank account information captured by you on the system. Tupperware, in its sole discretion, may make any necessary change to this payment process or introduce any other payment process if so required.</p>
                            <p style={{ fontWeight: "bold" }}>PROCESS TO CAPTURE BANK INFORMATION</p>
                            <p class="p14 ft4">If you consent to sharing of information on the eCommerce channel through the Mobi App, you will need to complete the Bank Information form on the Mobi App. To secure privacy of information, Bank Information form can only be entered into or when you want to change information, once a secure password has been created. This is not the password that you use to login to the Mobi app with. Once bank account information has been submitted, a secure link to a 3rd party application will be made to verify the bank information. This is to ensure that you have captured correct details.</p>
                            <p class="p15 ft0">If you no longer consent to have information shared on eCommerce channel, your bank information will be deleted permanently from the system, as well as your profile on the eCommerce channel.</p>
                        </div>
                        <div id="page_2">


                            <p style={{ fontWeight: "bold" }}>PRIVACY</p>
                            <p class="p17 ft0">Agreeing to the terms and conditions of this agreement is the basis for the legitimate processing of your personal information as described above. In addition, you agree that Tupperware may use your personal information in the furtherance of the business ineterst for yourself and Tupperware.</p>
                            <p class="p9 ft5">Legal Basis for Processing (Chapter 3 Part A)</p>
                            <p class="p18 ft0">With respect to the processing of Personal Information required for the performance of a contract to which the data subject is a party, the legal basis is provided by Section 11(1)(b) of Protection of Personal Information Act Act 4 of 2013 (hereafter referred to as POPIA).</p>
                            <p class="p19 ft0">We process your Personal Information in order to safeguard our legitimate interests, in particular to provide and maintain our IT infrastructure, to guarantee satisfactory customer communication and to promote the sale of our products Section 11(1)(d) of POPIA.</p>
                            <p class="p20 ft0">In exceptional cases, we may also use your data for the fulfilment of a legal obligation (Section 11(1)(c) of POPIA.), to safeguard vital interests (Section 11(1)(d) of POPIA), or to perform a task in the public interest (Section 11(1)(e) of POPIA).</p>
                            <p style={{ fontWeight: "bold" }}>Your rights as a Data Subject (Chapter 2 Section 5)</p>
                            <p class="p22 ft6">Right to information</p>
                            <p class="p23 ft0">You have the right, at any time upon request, to obtain information from us about your Personal Information concerning you in the Section 11 of POPIA.</p>
                            <p class="p22 ft6">Right to rectification</p>
                            <p class="p24 ft0">According to Section 5(1)(c) of POPIA, you have the right to ask us to rectify Personal Information you think is inaccurate. You also have the right to ask us to complete information you think is incomplete.</p>
                            <p class="p9 ft5">Right to deletion</p>
                            <p class="p25 ft0">You have the right to demand the deletion of your Personal Information under the conditions described in Section 5(1)(c) of POPIA .</p>
                            <p class="p22 ft6">Right to object (Chapter 3 Part A – Condition 2)</p>
                            <p class="p26 ft4">You have the right to object to processing if we are processing your Personal Information as part of our tasks in the public interest or based on our legitimate interests.</p>
                            <p class="p27 ft0">If you object to the processing of your Personal Information for advertising purposes, we will stop this processing in any case.</p>
                            <p class="p9 ft5">Exercise of these rights</p>
                            <p class="p28 ft0">If you wish to exercise these rights, please contact us at the email address: infoofficer@tupperware.com or physical address listed in the section entitled “Responsibility; Information Officer” below.</p>
                            <p class="p22 ft5">Withdrawal Section 11</p>
                            <p class="p29 ft4">If you have given us consent to the processing of your Personal Information, you can revoke it at any time by contacting us at the email address infoofficer@tupperware.com or physical address listed in the section entitled “Responsibility; Information Officer” below.</p>
                            <p class="p30 ft0">After receiving your request, we will cease to process your Personal Information, as long as we do not perform the respective data processing on a different legal basis (e.g., in order to be able to continue to fulfill contracts with you).</p>
                            <p class="p9 ft5">Complaint</p>
                            <p class="p31 ft0">You also have the right to appeal to a supervisory authority: Information Regulator - complaints.IR@justice.gov.za if you believe that the processing of your Personal Information infringes the POPIA.</p>
                            <p class="p21 ft5">Responsibility, Information Officer (Chapter 5 Part B Section 55)</p>
                            <p class="p32 ft0">The controller of your Personal Information is:</p>
                            <p class="p22 ft4">Tupperware Southern Africa (Pty) Ltd.</p>
                            <p class="p32 ft0">Building C, Wedgefield Office Park</p>
                            <p class="p16 ft4">17 Muswell Road South</p>
                            <p class="p16 ft0">Bryanston</p>
                        </div>
                        <div id="page_3">

                            <p class="p33 ft0">If you have any general comments or questions about privacy, if you wish to update any information we hold about you, or if you revoke your consent or object to a particular use of the data, or if you exercise your rights, you may contact us by <nobr>e-mail</nobr> or contact our information officer, at infoofficer@tupperware.com.</p>
                            <p style={{ fontWeight: "bold" }}>GENERAL</p>
                            <p class="p34 ft0">Any changes to the agreement and participation in the program will be communicated to you via sms/Whatsapp/your distributor. Continued participation following any changes being communicated is deemed that you have agreed to such changes and consent to the amended conditions.</p>
                            <p class="p10 ft0">This agreement shall in no way be construed as an employment or agency agreement between Tupperware, the Distributor and/or the independent sales force. This agreement does not entitle you to claim any status and or benefits in terms of the Basic Conditions of Employment Act 75 of 1997 or the Labour Relations Act 66 of 1995.</p>
                            <p class="p8 ft0">Either party may terminate this agreement giving the party one week’s notice. This agreement automatically ends if you are inactive and discontinued off the system as a result thereof.</p>
                            <p class="p35 ft0">By clicking on: “I agree“ is a confirmation and acknowledgement that you have read, understood and agree to the terms and conditions contained herein.</p>
                        </div>

                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggleTermsModal}>Close</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>
        );
    }
}


export default BankingInfo;